module.exports = __webpack_public_path__ + "static/media/add-button-icon.796995c8.svg";